import { render, staticRenderFns } from "./SummaryStatusActionsList.vue?vue&type=template&id=6a706dac&"
import script from "./SummaryStatusActionsList.vue?vue&type=script&lang=js&"
export * from "./SummaryStatusActionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports